import { Row } from 'antd';
import { StyledTag } from 'components/new-ui/base/tag/styles';
import { DeclarationParamsKeys, FilterTag } from './useDeclarationsFilters';
import Button from 'components/new-ui/base/button/Button';

type Props = {
    tags: FilterTag[];
    onClearTag: (key: string, value?: string) => void;
    onClearAll?: () => void;
};

const DeclarationFilterTags = ({ tags, onClearTag, onClearAll }: Props) => {
    if (!tags.length) {
        return null;
    }

    return (
        <>
            {tags.length > 0 && (
                <Row>
                    {tags?.map((t) => {
                        if (
                            t.key === DeclarationParamsKeys.DECLARATION_STATUS ||
                            t.key === DeclarationParamsKeys.DECLARATION_TYPE ||
                            t.key === DeclarationParamsKeys.DECLARATION_INTERNAL_TYPE
                        ) {
                            return (
                                <StyledTag
                                    key={`${t.key}-${t.value}`}
                                    closable
                                    onClose={(e) => {
                                        e.preventDefault();
                                        onClearTag(t.key, t.rawValue ?? t.value);
                                    }}
                                >
                                    {t.value}
                                </StyledTag>
                            );
                        }

                        return (
                            <StyledTag
                                key={`${t.key}-${t.value}`}
                                closable
                                onClose={(e) => {
                                    e.preventDefault();
                                    onClearTag(t.key);
                                }}
                            >
                                {t.value}
                            </StyledTag>
                        );
                    })}
                    {tags?.length > 0 && (
                        <Button type="link" onClick={onClearAll}>
                            Clear All Filters
                        </Button>
                    )}
                </Row>
            )}
        </>
    );
};

export default DeclarationFilterTags;
